// https://medium.com/@riccardopolacci/download-file-in-javascript-from-bytea-6a0c5bb3bbdb
export const downloadBlobFile = (blob: Blob, filename: string, extension = 'pdf') => {
  const fileName = `${filename}.${extension}`;
  // TypeScript complains about navigator.msSaveBlob not existing, and we don't support IE anyways
  // if (navigator.msSaveBlob) {
  //   // IE 10+
  //   navigator.msSaveBlob(blob, fileName);
  // } else {
    const link = document.createElement('a');
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  // }
}
